import { CircleCheck } from 'lucide-react';

const defaultHeading =
  'Join 500+ providers streamlining their ordering and medical record request process';

const defaultBullets = [
  'Send orders in seconds',
  'HIPAA-compliant',
  'Track delivery status',
];

interface ValuePropositionProps {
  heading?: string;
  bullets?: string[];
}

export function ValueProposition({
  heading = defaultHeading,
  bullets = defaultBullets,
}: ValuePropositionProps = {}) {
  return (
    <div className="p-6 bg-secondary rounded-lg h-full">
      <h2 className="text-marketing-24 mb-4">{heading}</h2>
      <ul className="space-y-3">
        {bullets.map(bullet => (
          <li key={bullet} className="flex items-center gap-2 text-body-small">
            <CircleCheck className="h-5 w-5 text-primary flex-shrink-0" />
            <span>{bullet}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
